export default "__VITE_ASSET__2821addf__"